/* eslint-disable */

import { useEffect } from 'react';

import { useAuditory } from '../provider/hooks';
import { updateStepLog } from '../provider/actions';
import { Monitoring } from '../utils/monitoring';

const RegisterAuditory = ({ authoring }) => {
  const { dispatch } = useAuditory();
  const paso = {
    paso: authoring.paso,
    pasoDescripcion: authoring.pasoDescripcion,
  };

  useEffect(() => {
    updateStepLog(dispatch, { ...paso });

    Monitoring.startPage({
      stepName: paso.pasoDescripcion,
      auditoryId: window.idAuditoria,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paso.paso, paso.pasoDescripcion]);

  return null;
};

export default RegisterAuditory;
